export default {
    cash: 'Cash',
    financed: 'Financed',
};
